/*  CWL DJ Mixer browser demo: the page around the plate.

    CwlDemo.start (root, { baseUrl, urls, assets })

    Mounts the plate on a CwlMixer and wires the transport beside it: Play / Stop, the tempo, tap
    tempo, the loop's name and the upload. The loop's name and tempo come from loop.json, fetched
    at once (it is 150 bytes); the Wasm, the worklet and the loop itself wait for Play.
*/

(function ()
{
    'use strict';

    function start (root, options)
    {
        options = options || {};
        const mixer = new CwlMixer ({ baseUrl: options.baseUrl, urls: options.urls });
        const q = (s) => root.querySelector (s);

        const logo = q ('.plate .logo');
        if (logo && logo.dataset.src) logo.src = new URL (logo.dataset.src, options.assets || options.baseUrl || location.href).href;

        const panel = CwlPanel.mount (root, mixer);

        const play = q ('.cwl-play'), tap = q ('.cwl-tap'), bpmValue = q ('.cwl-bpm-value');
        const name = q ('.cwl-loop-name'), status = q ('.cwl-status'), file = q ('.cwl-upload input');

        const paint = () =>
        {
            const s = mixer.state();
            play.textContent = s.playing ? 'Stop' : s.loading ? 'Loading' : 'Play';
            play.setAttribute ('aria-label', play.textContent);
            play.classList.toggle ('on', s.playing);
            play.disabled = s.loading;
            bpmValue.textContent = CwlParams.fixed (s.bpm, 1);
            if (s.loopName) name.textContent = s.loopName;
        };

        mixer.on ('state', paint);
        mixer.on ('error', (err) => { status.textContent = 'Could not start: ' + (err && err.message || err); });
        mixer.on ('ready', () => { status.textContent = ''; });
        mixer.on ('progress', (p) => { if (p.what === 'loop' && ! mixer.ready) status.textContent = 'Loading the loop… ' + Math.floor (100 * p.loaded / p.total) + '%'; });

        mixer.loadMeta().then ((meta) =>
        {
            // "AKELA - AYYYYY.wav" reads AKELA, AYYYYY.
            const src = (meta.source || meta.file || '').replace (/\.[^.]+$/, '').replace (/\s+-\s+/, ', ');
            mixer.loopName = meta.name || src;
            paint();
        }).catch (() => {});

        play.addEventListener ('click', () =>
        {
            if (mixer.playing) { mixer.stop(); return; }
            status.textContent = mixer.ready ? '' : 'Loading the mixer…';
            mixer.play().catch (() => {});
        });

        tap.addEventListener ('click', () => { mixer.tap(); });

        file.addEventListener ('change', async () =>
        {
            const f = file.files && file.files[0];
            if (! f) return;
            status.textContent = 'Decoding ' + f.name + '…';
            try
            {
                await mixer.loadUserFile (f);
                status.textContent = 'Tempo is ' + CwlParams.fixed (mixer.bpm, 1) + ' BPM. Tap along to set yours.';
            }
            catch (e) { status.textContent = 'That file could not be decoded: ' + (e && e.message || e); }
            file.value = '';
        });

        paint();
        return { mixer, panel };
    }

    window.CwlDemo = { start };
}) ();
